<div class="wrapper mb-2">
    <div class="row">
        <div class="col-md-5 col-sm-12 text-left">
            <img src="./assets/icons/arrow.svg">
            <span class="label-title ml-2 mr-3">Nova Recarga</span>
        </div>

        <div class="col-md-7 col-sm-12 p-0">
            <div class="row container-fluid menu-navegacao-borda m-0 bg-white">
                <div class="menu-navegacao-espacamento col d-flex align-items-center">
                    <span class="menu-navegacao-icone"></span>
                    <span class="menu-navegacao-texto select">PRODUTOS</span>
                    <span class="menu-navegacao-seta"></span>
                </div>
                <div class="menu-navegacao-espacamento d-flex align-items-center">
                    <span class="menu-navegacao-icone"></span>
                    <span class="menu-navegacao-texto select">FAVORECIDOS</span>
                    <span class="menu-navegacao-seta"></span>
                </div>
                <div class="menu-navegacao-espacamento d-flex align-items-center">
                    <span class="menu-navegacao-icone"></span>
                    <span class="menu-navegacao-texto select">CRÉDITO</span>
                    <span class="menu-navegacao-seta"></span>
                </div>
                <div class="menu-navegacao-espacamento d-flex align-items-center">
                    <span class="menu-navegacao-icone"></span>
                    <span class="menu-navegacao-texto select">CONFIRMAÇÃO</span>
                    <span class="menu-navegacao-seta"></span>
                </div>
                <div class="menu-navegacao-espacamento d-flex align-items-center">
                    <span class="menu-navegacao-icone"></span>
                    <span class="menu-navegacao-texto">PAGAMENTO</span>
                </div>
            </div>
        </div>

        <form [formGroup]="confirmarPedidoFormGroup" #confirmarPedidoForm="ngForm" (ngSubmit)="onSubmit(confirmarPedidoFormGroup.value)" class="component-box container-fluid">
            <div class="container-fluid">
                <div class="col-lg-12 col-md-12 col-sm-12 text-left component-title mt-2 mb-1">

                    <div class="row button-container mt-5 mb-3">
                        <div class="col-6 text-left px-0">
                            <p class="component-title" style="font-size: 24px;">Confirme sua recarga</p>
                        </div>
                    </div>

                    <div class="row">
                        <div class="container-fluid col-6 px-2 component-box" style="border: 1px solid #DEDEDE;">
                            <div class="clean-title-span text-center my-2 col-12 mx-auto">
                                Informações de Pagamento
                            </div>
                            <div class="clean-container  p-2 row">
                                <div class="container-fluid">
                                    <!-- <div class="form-title text-center">Valor a pagar:
                                        <span *ngIf="currentPedidoValue.pagamento.valorPagar > 0">
                                            {{currentPedidoValue.pagamento.valorPagar | currency:'BRL':true}}
                                        </span>

                                        <span *ngIf="currentPedidoValue.pagamento.valorPagar <= 0">R$ 0,00</span>
                                    </div> -->

                                </div>

                                <div *ngIf="saldoDisponivel > 0" class="my-4 col-12 mx-auto">
                                    <div class="clean-text">
                                        Você possui
                                        <span class="clean-text-span"> {{saldoDisponivel | currency:'BRL':true}}</span>
                                        de saldo disponível.
                                    </div>
                                    <div class="clean-text ">
                                        Valor da Recarga:
                                        <span class="clean-text-span"> {{currentPurchaseValue.purchaseValue | currency: 'BRL': true}}</span>
                                    </div>
                                    <br/>
                                    <div *ngIf="saldoDisponivel >= currentPurchaseValue.purchaseValue" class="form-check-inline">
                                        <input formControlName="utilizarSaldo" id="utilizarSaldoCheckbox" class="checkbox mx-2" type="checkbox" (change)="aplicarUtilizarSaldo()"/>

                                        <label for="utilizarSaldoCheckbox" class="clean-text form-check-label">
                                            Utilizar meu saldo para essa recarga
                                        </label>
                                    </div>
                                </div>
                                <div *ngIf="currentPurchaseValue.purchaseValue >= 0 && !form.utilizarSaldo.value">
                                    <div class="clean-text">
                                        Para que a recarga seja processado, você precisará adicionar <span class="clean-text-span">{{currentPurchaseValue.purchaseValue | currency:'BRL':true}}</span>  de crédito em sua conta.
                                    </div>
                                    <br/>
                                    <div class="clean-title-span">
                                        Selecione uma forma de depósito:
                                    </div>
                                    <div *ngIf="boleto" class="custom-input-container form-check-inline my-2 col-8 mx-auto">
                                        <input formControlName="paymentMethodId" name="paymentMethodId" [attr.id]="meioPagamentoPedidoTela.Boleto" type="radio" class="radio" [value]="meioPagamentoPedidoTela.Boleto" (click)="selectMeioPagamentoBoleto();loadMinDateTime(meioPagamentoPedidoTela.Boleto)"/>

                                        <label [attr.for]="meioPagamentoPedidoTela.Boleto" class="radio-label">
                                            <span class="mx-2 clean-text">Boleto</span>
                                        </label>
                                    </div>

                                    <!---->
                                    <div *ngIf="form.paymentMethodId.value == meioPagamentoPedidoTela.Boleto" class="col">
                                        <p class="component-subtitle">Selecione a data de vencimento do boleto</p>
                                        <div class="row">

                                            <div class="mx-3 ">
                                                <div class="input-group">
                                                    <input class="form-control " placeholder="dia/mês/ano" [(ngModel)]="confirmarPedidoCadastro.dataVencimento" [dayTemplate]="customDay" [markDisabled]=" isDisabled" [ngModelOptions]="{standalone: true}" ngbDatepicker #d="ngbDatepicker" [readonly]="true">
                                                    <div class="input-group-append">
                                                        <button class="btn btn-outline-secondary calendar" (click)="d.toggle()" type="button"></button>
                                                    </div>
                                                </div>

                                                <ng-template class="custom-hover" #customDay let-date let-currentMonth="currentMonth" let-selected="selected" let-disabled="disabled" let-focused="focused">
                                                    <span class="custom-btn" [class.focused]="focused" [class.text-muted]="disabled">
                                                        {{ date.day }}
                                                    </span>
                                                </ng-template>
                                            </div>

                                            <div *ngIf="form.dataVencimento.invalid && (form.dataVencimento.dirty || form.dataVencimento.touched)" class="alert alert-danger text-center my-4 col-8 mx-auto" role="alert">
                                                <div *ngIf="form.dataVencimento.errors.required">
                                                    Data de vencimento é obrigatória
                                                </div>

                                                <div *ngIf="form.dataVencimento.errors.minDate">
                                                    Data de vencimento inválida
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <!---->

                                    <div *ngIf="transferencia" class="custom-input-container form-check-inline my-2 col-8 mx-auto">
                                        <input formControlName="paymentMethodId" name="paymentMethodId" [attr.id]="meioPagamentoPedidoTela.Transferencia"
                                        type="radio" class="radio" [value]="meioPagamentoPedidoTela.Transferencia"
                                        (click)="loadMinDateTime(meioPagamentoPedidoTela.Transferencia)"/>

                                        <label [attr.for]="meioPagamentoPedidoTela.Transferencia" class="radio-label">
                                            <span class="mx-2 clean-text">Transferência PIX</span>
                                        </label>
                                    </div>

                                    <!-- <div *ngIf="showTransferencia" class="form-box form-check-inline my-2 col-8 mx-auto row p-2">

                                        <div *ngIf="dadoBancarioCedenteList && dadoBancarioCedenteList.length > 0" class="col-12 clean-title"></div>

                                        <div class="col-12">
                                            <select *ngIf="dadoBancarioCedenteList && dadoBancarioCedenteList.length > 0" formControlName="dadoBancarioGuid" (change)="selectDadoBancario()" class="w-100">

                                                <option *ngFor="let item of dadoBancarioCedenteList"
                                                    [value]="item.dadoBancarioGuid"
                                                    [selected]="item.preferencial === true">
                                                    {{item.bancoNome}} - {{item.agencia}} - {{item.digitoAgencia}} -
                                                    {{item.conta}} - {{item.digitoConta}}
                                                </option>
                                            </select>

                                            <div *ngIf="dadoBancarioCedenteList && dadoBancarioCedenteList.length <= 0" class="clean-text">
                                                Nenhum dado bancário encontrado, por favor cadastre uma conta para utilizar a transferência
                                            </div>

                                            <div *ngIf="form.dadoBancarioGuid.invalid && (form.dadoBancarioGuid.dirty || form.dadoBancarioGuid.touched)" class="alert alert-danger text-center my-4 col-8 mx-auto" role="alert">
                                                <div *ngIf="form.dadoBancarioGuid.errors.required" class="clean-text">
                                                    Para realizar o pagamento por transferência selecione sua conta de origem
                                                </div>
                                            </div>

                                            <div class="mt-4 mb-2">
                                                <span class="clickable clean-title-span" (click)="newDadosBancarios()">Cadastrar nova
                                                    conta</span>
                                            </div>
                                        </div>
                                    </div>        -->

                                    <div *ngIf="form.paymentMethodId.invalid && (form.paymentMethodId.dirty || form.paymentMethodId.touched)" class="alert alert-danger text-center my-4 col-8 mx-auto" role="alert">
                                        <div *ngIf="form.paymentMethodId.errors.required">
                                            Meio de pagamento é obrigatório!
                                        </div>
                                    </div>
                                </div>
                                <br/><br>
                                <hr>
                                <div class="">
                                    <p class="clean-text-span">Observações:</p>
                                    <p class="clean-text-muted" style="font-size: 18px;">
                                        - Ao selecionar o meio de pagamento Boleto, a compensação e liberação dos recursos levará 2 dias úteis após a data do pagamento, portanto, certifique-se de programar corretamente a data de liberação para que haja saldo suficiente no momento do processamento da recarga.
                                        <br><br>
                                        - Ao selecionar o meio de pagamento Transferência PIX, certifique que você realizará o pagamento antes do dia e hora da liberação para que haja saldo suficiente no momento do processamento da recarga.
                                        <br><br>
                                        - O valor da recarga será descontado do saldo disponível no momento da disponíbilização aos seus favorecidos.
                                        <br><br>
                                        - Adicione créditos em sua conta através do menu financeiro e atribua incentivos a seus favorecidos a qualquer momento.
                                    </p>
                                </div>
                            </div>
                        </div>

                        <div class="container-fluid col-6 px-2 component-box" style="border: 1px solid #DEDEDE;">
                            <div class="p-2">
                                <div class="clean-title-span text-center mb-3 mt-2">Dados da recarga</div>

                                <div class="col-lg-12 col-md-12 col-sm-12 mt-5 mb-5 text-center">
                                    <div class="col-6 " style="display: inline-block;" *ngFor="let item of currentPurchaseValue.purchaseItens let i = index; ">

                                        <p class="component-subtitle">{{currentPurchaseValue.purchaseItens[i].order.productDescription}}</p>
                                        <div class="imgCard">
                                            <app-svg-card [color]="item.order.productColor" [icon]="item.order.productIcon" [name]="item.order.productDescription"></app-svg-card>
                                        </div>
                                        <!--img [src]="'./assets/icons/produtos/icon-produtos/'+ currentPurchaseValue.purchaseItens[i].order.productGuid +'.svg'" onerror="this.src='./assets/icons/produtos/icon-produtos/SemImagem.svg';" class="imgCard" alt="{{currentPurchaseValue.purchaseItens[i].order.productDescription}}" /-->
                                    </div>
                                </div>
                                <div *ngIf="currentPurchaseValue.purchaseValuePay == 0" class="form-check-inline text-center col my-2">
                                    <input formControlName="liberarImediatamente" id="disponibilizarBeneficioImediato" class="checkbox mx-2" type="checkbox" />

                                    <label for="disponibilizarBeneficioImediato" class="clean-text form-check-label">
                                        Disponibilizar crédito imediatamente
                                    </label>
                                </div>
                                <div *ngIf="!form.liberarImediatamente.value" class="col my-2">
                                    <p class="component-subtitle text-center">Selecione a data e hora de disponibilização do crédito para os favorecidos</p>
                                    <div class="row justify-content-center align-items-center">

                                        <div class="mx-3  text-center">
                                            <div class="input-group">
                                                <input class="form-control text-center" placeholder="dia/mês/ano" [(ngModel)]="confirmarPedidoCadastro.dataLiberacao" [dayTemplate]="customDay" [markDisabled]=" isDisabled" [ngModelOptions]="{standalone: true}" ngbDatepicker #d="ngbDatepicker" [readonly]="true">
                                                <div class="input-group-append">
                                                    <button class="btn btn-outline-secondary calendar" (click)="d.toggle()" type="button"></button>
                                                </div>
                                            </div>

                                            <ng-template class="custom-hover" #customDay let-date let-currentMonth="currentMonth" let-selected="selected" let-disabled="disabled" let-focused="focused">
                                                <span class="custom-btn" [class.focused]="focused" [class.text-muted]="disabled">
                                                    {{ date.day }}
                                                </span>
                                            </ng-template>
                                        </div>

                                        <div class="text-center">
                                            <ngb-timepicker [(ngModel)]="confirmarPedidoCadastro.horaLiberacao" [ngModelOptions]="{standalone: true}" [minuteStep]="0" required="true">
                                            </ngb-timepicker>
                                        </div>

                                        <div class="text-center div-top-just">
                                            <span class="span-hour">: 00</span>
                                        </div>


                                        <div *ngIf="form.dataLiberacao.invalid && (form.dataLiberacao.dirty || form.dataLiberacao.touched)" class="alert alert-danger text-center my-4 col-8 mx-auto" role="alert">
                                            <div *ngIf="form.dataLiberacao.errors.required">
                                                Data de liberação é obrigatória
                                            </div>

                                            <div *ngIf="form.dataLiberacao.errors.minDate">
                                                Data de liberação inválida
                                            </div>
                                        </div>

                                        <div *ngIf="form.horaLiberacao.invalid && (form.horaLiberacao.dirty || form.horaLiberacao.touched)" class="alert alert-danger text-center my-4 col-8 mx-auto" role="alert">
                                            <div *ngIf="form.horaLiberacao.errors.required">
                                                Hora de liberação é obrigatória
                                            </div>

                                            <div *ngIf="form.horaLiberacao.errors.minTime">
                                                Hora de liberação inválida
                                            </div>
                                        </div>
                                    </div>

                                    <div *ngIf="false" class="text-danger">
                                        <div *ngIf="false">
                                            <p class="text-center font-weight-normal">Selecione a data e hora de disponibilização do incentivos.</p>
                                        </div>
                                    </div>
                                </div>

                                <div class="col-8 mx-auto my-5">
                                    <div class="row">
                                        <div class="col-6 text-left component-subtitle" *ngIf="currentPurchaseValue.identifier">Nome da Recarga
                                        </div>

                                        <div class="col-6 text-left component-subtitle" *ngIf="currentPurchaseValue.identifier">
                                            {{currentPurchaseValue.identifier}}</div>
                                        <div class="col-6 text-left component-subtitle">Produtos</div>

                                        <div class="col-6 text-left component-subtitle">
                                            <div *ngFor="let item of currentPurchaseValue.purchaseItens">
                                                {{item.order.productDescription}}
                                            </div>
                                        </div>
                                        <div class="col text-left component-title">Valor</div>

                                        <div class="col text-left component-title">
                                            {{currentPurchaseValue.purchaseValue | currency: 'BRL': true}}
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="container-fluid mt-3 mb-3">
                <div class="row">
                    <div class="col text-right">
                        <!--<button type="button" (click)="savePedido()" class="custom-button-outline mx-4">
                            SALVAR
                        </button>-->

                        <button (click)="previous()" type="button" class="custom-button-back">Voltar</button>

                        <button *ngIf="(validarPin && !pinValido && !isResposavel)" (click)="showModalPin(modalPin)" type="button" class="custom-button-full">Solicitar Pin</button>
                        <button *ngIf="(validarPin && pinValido && !isResposavel) || isResposavel || !validarPin" type="submit" class="custom-button-full">Continuar</button>
                    </div>
                </div>
            </div>

        </form>
    </div>
</div>

<!-- Modal Pin -->
<ng-template #modalPin let-modal>
    <div class="col-12 modal-header clean-modal-header">
        <div class="col-md-12">
            <h5 class="clean-modal-title">Solicitação de Pin</h5>
        </div>
    </div>
    <div class="row px-4 d-flex justify-content-end ">
        <p class="col-12 clean-modal-subtitle" style="font-size: 20px;">
            Digite o PIN enviado por e-mail para concluir a recarga:
        </p>
        <div class="col-12 mb-4">
            <div class="text-center">
                <input class="clean-filter-input w-25" id="pin" type="number" #pin />
            <span class="message-error" *ngIf="pinMensagemErro">
                {{ pinMensagemErro }}
            </span>
            </div>
        </div>
    </div>

    <div class="col-12 clean-modal-footer">
        <button class="custom-filter-button button-cancel mr-2" (click)="modal.dismiss('Close click')">
            Cancelar
        </button>
        <button class="custom-modal-button" type="button" (click)="verificarPin(pin.value)">
            Confirmar
        </button>
    </div>
</ng-template>
